import { ITemplate } from '@entities/template/model';
import { TemplateDto } from '@entities/template/api';

export const mapTemplateDto = (dto: TemplateDto): ITemplate => {
  return {
    id: dto.fileId,
    templateName: dto.name,
    templateNumber: dto.templateNumber,
  };
};
